module.exports = __webpack_public_path__ + "static/media/delete.ce69486f.svg";